import {mapActions} from "vuex";

export default {
    beforeMount() {

    },

    methods: {
        ...mapActions({
            setFilteredSiteGroupsList(dispatch, payload){
                return dispatch(this.namespace + '/setFilteredSiteGroupsList', payload);
            },
            setFilteredNetworkList(dispatch, payload){
                return dispatch(this.namespace + '/setFilteredNetworkList', payload);
            },
        }),
        _getBaseData() {
            var that = this;

            let objects = null;

            objects = this.$store.dispatch(this.namespace + '/getBaseData');

            objects.then(function(result)
            {
                if (result !== undefined)
                {
                    if ( result.sites ) {
                        that._storeSites(result.sites.toArray());
                    }

                    let partners = [];
                    if ( result.partners ) {
                        for(let partner of result.partners.values() )  {
                            partners.push(partner);
                        }
                    }

                    if (result.sources) {
                        for(let source of result.sources.values() )  {
                            partners.push(source);
                        }                        
                    }

                    if( partners.length > 0 ) {
                        that._storeSources(partners);
                    }

                    if (result.markets) {
                        that._storeMarkets(result.markets.toArray());
                    }

                    if (result.devices) {
                        that._storeDevices(result.devices.toArray());
                    }

                    if (result.siteGroups ) {
                        that._storeSiteGroups(result.siteGroups.toArray());
                    }

                    if (result.networks) {
                        that._storeNetworks(result.networks.toArray());
                    }

                    that._updateParameters();
                    that.finishLoading();
                    that.setUpdatingStatus(true);
                }
            });
        },

        _storeSiteGroups(items) {
            this.$store.dispatch(this.namespace + '/setSiteGroupsList', items);
        },
        _storeSites(items) {
            this.$store.dispatch('setSitesList', items);
        },
        _storeSources(items) {
            this.$store.dispatch('setPartnersList', items);
        },
        _storeMarkets(items) {
            this.$store.dispatch('setMarketsList', items);
        },
        _storeDevices(items) {
            this.$store.dispatch('setDevicesList', items);
        },
        _storeNetworks(items) {
            this.$store.dispatch(this.namespace + '/setNetworkList', items);
        },
        _storePartners(items) {
            this.$store.dispatch('setPartnersList', items);
        },
        getSiteGroupsList: function () {
            return this.$store.getters[this.namespace + '/getSiteGroupsList'];
        },
        getSelectedSiteGroupsList: function () {
            return this.$store.getters[this.namespace + '/getSelectedSiteGroupsList'];
        },
        getSelectedSiteGroupsObjects(){
            return this.$store.getters[this.namespace + '/getSelectedSiteGroupsObjects'];
        },
        updateFilteredSiteGroupsList(value){
            this._setFilteredSitesList(value);
            this.clearPagination();
            this.setUpdatingStatus(true);
            this.startLoading();
            this.checkFilters();
        },
        removeFilteredSiteGroupsList(value){
            this.updateFilteredSiteGroupsList(value);
            this.removeParamFromUrl('siteGroups');
        },
        _setFilteredSitesList(value) {
            this.setFilteredSitesList(value);
        },
        getNetworkList: function () {
            return this.$store.getters[this.namespace + '/getNetworkList'];
        },
        getSelectedNetworkList: function () {
            return this.$store.getters[this.namespace + '/getSelectedNetworkList'];
        },
        getSelectedNetworkObjects(){
            return this.$store.getters[this.namespace + '/getSelectedNetworkObjects'];
        },
        updateFilteredNetworkList(value){
            this._setFilteredNetworkList(value);
            this.clearPagination();
            this.setUpdatingStatus(true);
            this.startLoading();
            this.checkFilters();
        },
        removeFilteredNetworkList(value){
            this.updateFilteredNetworkList(value);
            this.removeParamFromUrl('networks');
        },
        _setFilteredNetworkList(value) {
            this.setFilteredNetworkList(value);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/scrubRateHourlyReportMixin.js